import { Box, Heading, HStack, Stack, Text } from '@chakra-ui/react'
import { FC } from 'react'
import ErrorOctagon from 'src/components/icons/ErrorOctagon'
import { cdsColors, fontSizes } from 'src/theme/theme'

export const AccountLockedBanner: FC = () => {
  return (
    <Box bg="cds.red.100" borderWidth="1px" borderColor="cds.red.300" borderRadius="4px" p="20px">
      <HStack spacing="16px" align="center">
        <Box flexShrink={0}>
          <ErrorOctagon width="24px" height="24px" color={cdsColors.red[600]} />
        </Box>
        <Stack spacing="4px" flex={1}>
          <Heading
            as="h2"
            fontSize={fontSizes.lg}
            fontWeight="600"
            lineHeight="1.5"
            letterSpacing="0.15px"
            color="cds.neutralGray.900"
          >
            アカウントがロックされました
          </Heading>
          <Text
            fontSize={fontSizes.md}
            lineHeight="1.5"
            letterSpacing="0.25px"
            color="cds.neutralGray.900"
          >
            連続してログインに失敗したため、一時的にロックされました。しばらく時間をおいて再操作してください。
          </Text>
        </Stack>
      </HStack>
    </Box>
  )
}
